import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import classNames from 'classnames/bind';
import { bool, object, shape, string } from 'prop-types';
import { TextBase } from "../../../internal/TextBase";
import { Button } from '../../../Button';
import Title from '../../../Title';
import styles from './Actions.css';
var cx = classNames.bind(styles);
export var Actions = function Actions(_ref) {
  var mobile = _ref.mobile,
      pristine = _ref.pristine,
      disabled = _ref.disabled,
      validationErrors = _ref.validationErrors,
      messages = _ref.messages,
      buttonTheme = _ref.buttonTheme,
      submitButtonProps = _ref.submitButtonProps;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('root')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('buy_info')
  }, /*#__PURE__*/React.createElement(Title, {
    level: mobile ? 4 : 3
  }, messages.amount), /*#__PURE__*/React.createElement(TextBase, {
    color: "N900",
    size: mobile ? 's' : 'm'
  }, mobile ? messages.buyInfoMobile : messages.buyInfo)), /*#__PURE__*/React.createElement("div", {
    className: cx('button')
  }, /*#__PURE__*/React.createElement(Button, _extends({
    block: true,
    disabled: pristine || disabled || validationErrors,
    size: "large",
    theme: buttonTheme,
    type: "submit"
  }, submitButtonProps), messages.actionButton)));
};
Actions.propTypes = process.env.NODE_ENV !== "production" ? {
  disabled: bool,
  pristine: bool,
  validationErrors: bool,
  mobile: bool,
  messages: shape({
    buyInfoMobile: string,
    buyInfo: string,
    amount: string,
    actionButton: string
  }),
  buttonTheme: string,
  submitButtonProps: object
} : {};
Actions.defaultProps = {
  messages: {}
};